// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.relatorios-container {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.relatorios-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  gap: 20px;
  flex-wrap: wrap;
}

.filter-section {
  flex: 1 1;
  min-width: 200px;
}

.export-buttons {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.export-buttons .btn {
  white-space: nowrap;
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.empty-state h3 {
  color: #333;
  margin-bottom: 10px;
}

.empty-state p {
  color: #666;
}

.campeoes-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 25px;
}

.campeao-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  overflow: hidden;
  transition: transform 0.3s, box-shadow 0.3s;
}

.campeao-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 12px rgba(0,0,0,0.15);
}

.campeao-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.campeao-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.faixa-badge {
  background: rgba(255,255,255,0.2);
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
}

.podio {
  padding: 20px;
}

.podio-item {
  display: flex;
  align-items: center;
  padding: 15px;
  margin-bottom: 12px;
  border-radius: 8px;
  transition: all 0.3s;
}

.podio-item:hover {
  transform: translateX(5px);
}

.podio-item.primeiro {
  background: linear-gradient(135deg, #fff9e6 0%, #ffe9b3 100%);
  border-left: 5px solid #FFD700;
}

.podio-item.segundo {
  background: linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%);
  border-left: 5px solid #C0C0C0;
}

.podio-item.terceiro {
  background: linear-gradient(135deg, #fff3e6 0%, #ffe0cc 100%);
  border-left: 5px solid #CD7F32;
}

.podio-medal {
  font-size: 36px;
  margin-right: 15px;
  min-width: 50px;
  text-align: center;
}

.podio-info {
  flex: 1 1;
}

.podio-posicao {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  color: #666;
  margin-bottom: 4px;
}

.podio-nome {
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin-bottom: 4px;
}

.podio-academia {
  font-size: 13px;
  color: #666;
  font-style: italic;
}

/* Responsividade */
@media (max-width: 768px) {
  .relatorios-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .filter-section {
    width: 100%;
  }

  .export-buttons {
    flex-direction: column;
  }

  .export-buttons .btn {
    width: 100%;
  }

  .campeoes-grid {
    grid-template-columns: 1fr;
  }

  .campeao-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .podio-item {
    flex-direction: column;
    text-align: center;
  }

  .podio-medal {
    margin-right: 0;
    margin-bottom: 10px;
  }
}

/* Animações */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.campeao-card {
  animation: slideIn 0.5s ease-out;
}

.campeao-card:nth-child(1) { animation-delay: 0.1s; }
.campeao-card:nth-child(2) { animation-delay: 0.2s; }
.campeao-card:nth-child(3) { animation-delay: 0.3s; }
.campeao-card:nth-child(4) { animation-delay: 0.4s; }
.campeao-card:nth-child(5) { animation-delay: 0.5s; }
`, "",{"version":3,"sources":["webpack://./src/pages/Relatorios.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6DAA6D;EAC7D,8BAA8B;AAChC;;AAEA;EACE,6DAA6D;EAC7D,8BAA8B;AAChC;;AAEA;EACE,6DAA6D;EAC7D,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA,cAAc;AACd;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,gCAAgC;AAClC;;AAEA,6BAA6B,qBAAqB,EAAE;AACpD,6BAA6B,qBAAqB,EAAE;AACpD,6BAA6B,qBAAqB,EAAE;AACpD,6BAA6B,qBAAqB,EAAE;AACpD,6BAA6B,qBAAqB,EAAE","sourcesContent":[".relatorios-container {\n  padding: 20px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.relatorios-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.filter-section {\n  flex: 1;\n  min-width: 200px;\n}\n\n.export-buttons {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.export-buttons .btn {\n  white-space: nowrap;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.empty-state h3 {\n  color: #333;\n  margin-bottom: 10px;\n}\n\n.empty-state p {\n  color: #666;\n}\n\n.campeoes-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));\n  gap: 25px;\n}\n\n.campeao-card {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0,0,0,0.1);\n  overflow: hidden;\n  transition: transform 0.3s, box-shadow 0.3s;\n}\n\n.campeao-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 12px rgba(0,0,0,0.15);\n}\n\n.campeao-header {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.campeao-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.faixa-badge {\n  background: rgba(255,255,255,0.2);\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.podio {\n  padding: 20px;\n}\n\n.podio-item {\n  display: flex;\n  align-items: center;\n  padding: 15px;\n  margin-bottom: 12px;\n  border-radius: 8px;\n  transition: all 0.3s;\n}\n\n.podio-item:hover {\n  transform: translateX(5px);\n}\n\n.podio-item.primeiro {\n  background: linear-gradient(135deg, #fff9e6 0%, #ffe9b3 100%);\n  border-left: 5px solid #FFD700;\n}\n\n.podio-item.segundo {\n  background: linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%);\n  border-left: 5px solid #C0C0C0;\n}\n\n.podio-item.terceiro {\n  background: linear-gradient(135deg, #fff3e6 0%, #ffe0cc 100%);\n  border-left: 5px solid #CD7F32;\n}\n\n.podio-medal {\n  font-size: 36px;\n  margin-right: 15px;\n  min-width: 50px;\n  text-align: center;\n}\n\n.podio-info {\n  flex: 1;\n}\n\n.podio-posicao {\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: #666;\n  margin-bottom: 4px;\n}\n\n.podio-nome {\n  font-size: 16px;\n  font-weight: 700;\n  color: #333;\n  margin-bottom: 4px;\n}\n\n.podio-academia {\n  font-size: 13px;\n  color: #666;\n  font-style: italic;\n}\n\n/* Responsividade */\n@media (max-width: 768px) {\n  .relatorios-actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .filter-section {\n    width: 100%;\n  }\n\n  .export-buttons {\n    flex-direction: column;\n  }\n\n  .export-buttons .btn {\n    width: 100%;\n  }\n\n  .campeoes-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .campeao-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  .podio-item {\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .podio-medal {\n    margin-right: 0;\n    margin-bottom: 10px;\n  }\n}\n\n/* Animações */\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.campeao-card {\n  animation: slideIn 0.5s ease-out;\n}\n\n.campeao-card:nth-child(1) { animation-delay: 0.1s; }\n.campeao-card:nth-child(2) { animation-delay: 0.2s; }\n.campeao-card:nth-child(3) { animation-delay: 0.3s; }\n.campeao-card:nth-child(4) { animation-delay: 0.4s; }\n.campeao-card:nth-child(5) { animation-delay: 0.5s; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
